import React from "react";
import { TextModalProps } from "../../types/screensTypes";
import styles from "./ProjectTextModal.module.css";
import { ModalPortal } from "./ModalPortal";

const TextModal: React.FC<TextModalProps> = ({ isOpen, onClose, title, content }) => {
    if (!isOpen) return null;

    return (
        <ModalPortal>
            <div className={styles.overlay} onClick={onClose}>
                <div className={styles.content} onClick={(e) => e.stopPropagation()}>
                    <button type="button" className={styles.close} onClick={onClose}>
                        ✕
                    </button>
                    <div className={styles.header}>
                        <h2 className={styles.title}>{title}</h2>
                    </div>
                    <div className={styles.body}>{content}</div>
                </div>
            </div>
        </ModalPortal>
    );
};

export default TextModal;
